import * as React from 'react';

import { Select, SelectProps } from '@emburse/ui-core';

import { IParentCardOption } from '@ClientApi/cardIssuing';

interface IParentCardSelectProps extends Omit<SelectProps, 'children' | 'id'> {
  parentCards: IParentCardOption[];
}

export const ParentCardSelect: React.FC<IParentCardSelectProps> = ({ parentCards, ...rest }) => (
  <Select fullWidth required label="Parent Card" native id="parent-card-select" name="parent-card-select" disabled {...rest}>
    <option aria-label="none" value="" />
    {parentCards.map((card) => (
      <option key={card.id} value={card.id}>
        {card.displayName}
      </option>
    ))}
  </Select>
);
